/**
 * Temas oficiales: mismo catálogo que ACV vía @acv/theme-tokens (ACV/packages/acv-theme-tokens) — sin HTTP para ids embebidos.
 * Custom / no encontrado en bundle → API (ThemesApplyingImprovements §5 + paridad Admin Center).
 */
import {
  getBundledOfficialThemeById,
  getModuleThemeIdFromLocalStorageSync,
} from '@acv/theme-tokens';
import { ThemesApiClient } from '../lib/themesApi';

export function normalizeStoredThemeId(raw: unknown): string | null {
  if (typeof raw === 'string') return raw;
  if (
    raw &&
    typeof raw === 'object' &&
    raw !== null &&
    'themeId' in raw &&
    typeof (raw as { themeId?: string }).themeId === 'string'
  ) {
    return (raw as { themeId: string }).themeId;
  }
  return null;
}

/** Sin round-trip: themeId en localStorage → objeto oficial desde el bundle (mismo repo que ACV). */
export function tryBundledThemeForModule(moduleId: string): Record<string, unknown> | null {
  const raw = getModuleThemeIdFromLocalStorageSync([moduleId]);
  const tid = normalizeStoredThemeId(raw);
  if (!tid) return null;
  const bundled = getBundledOfficialThemeById(tid);
  return bundled ? (bundled as Record<string, unknown>) : null;
}

export async function resolveThemeById(themeId: string | null | undefined) {
  if (!themeId || typeof themeId !== 'string') return null;
  const bundled = getBundledOfficialThemeById(themeId);
  if (bundled) return bundled as Record<string, unknown>;
  return ThemesApiClient.getThemeById(themeId);
}
